<template>
  <Select v-model="selectedValue"
          :options="props.options"
          :optionLabel="val => val.title"
          :optionValue="val => val"
          v-bind="$attrs"
          filter
          showClear
  >
    <template #value="slotProps">
      <div v-if="slotProps.value" class="flex items-center">
        <div>{{ slotProps.value.title }}</div>
      </div>
    </template>
    <template #option="slotProps">
      <div class="flex items-center">
        <div>{{ slotProps.option.title }}</div>
      </div>
    </template>
  </Select>

</template>

<script setup>
import {computed, watch} from "vue"

const props = defineProps({
  modelValue: {
    required: true
  },
  options: {
    type: Array,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

const selectedValue = computed({
  get: () => props.options.find(option => option.value === props.modelValue) ?? null,
  set: value => emit('update:modelValue', value?.value ?? null)
})

watch([() => props.modelValue, () => props.options], ([modelValue, options]) => {
  if (modelValue == null || options.length === 0) return
  if (options.some(option => option.value === modelValue)) return
  emit('update:modelValue', null)
}, {immediate: true})


</script>
